import {Component, OnInit} from '@angular/core';
import {GTMService} from "@portal/shared/services/gmt-service";
import {environment} from '../environments/environment';
import {DOCUMENT} from '@angular/common';
import {Inject} from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    constructor(
        private gtmService: GTMService,
        @Inject(DOCUMENT) private document: Document
    ) {}

    ngOnInit() {
        this.gtmService.initializeGTM();
        this.setFaviconBasedOnEnvironment();
    }

    private setFaviconBasedOnEnvironment(): void {
        // Check if should show staging indicator
        const showStagingIndicator = (environment as any).showStagingIndicator === true;
        const isStaging = showStagingIndicator || 
                         (environment as any).isStaging === true ||
                         this.isStagingByHostname();

        if (isStaging) {
            // Use staging favicon - create a canvas-based favicon with staging indicator
            this.createStagingFavicon();
        } else {
            // Production favicon
            this.updateFavicon('assets/images/logo/O360_mini_white.png');
        }
    }

    private isStagingByHostname(): boolean {
        const hostname = this.document.location.hostname;
        return hostname.includes('staging') || 
               hostname.includes('stage') || 
               hostname === 'portal-dev.organiza360.pt' ||
               (hostname.includes('dev') && hostname.includes('organiza360.pt'));
    }

    private createStagingFavicon(): void {
        // Create a canvas to draw the staging favicon
        const canvas = this.document.createElement('canvas');
        canvas.width = 32;
        canvas.height = 32;
        const ctx = canvas.getContext('2d');

        if (!ctx) {
            // Fallback if canvas is not supported
            this.updateFavicon('assets/images/logo/O360_mini_white.png');
            return;
        }

        // Load the original favicon image
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => {
            // Draw the original image
            ctx.drawImage(img, 0, 0, 32, 32);
            
            // Add a small orange/amber indicator dot in the top-right corner
            ctx.fillStyle = '#f59e0b'; // Amber color for staging
            ctx.beginPath();
            ctx.arc(26, 6, 4, 0, 2 * Math.PI);
            ctx.fill();
            
            // Add a border to make it more visible
            ctx.strokeStyle = '#ffffff';
            ctx.lineWidth = 1;
            ctx.stroke();

            // Convert canvas to data URL and set as favicon
            const dataUrl = canvas.toDataURL('image/png');
            this.updateFavicon(dataUrl);
        };

        img.onerror = () => {
            // Fallback if image fails to load
            this.updateFavicon('assets/images/logo/O360_mini_white.png');
        };

        img.src = 'assets/images/logo/O360_mini_white.png';
    }

    private updateFavicon(iconPath: string): void {
        const linkElements = this.document.querySelectorAll("link[rel*='icon']");
        
        // Remove existing favicon links
        linkElements.forEach(link => {
            this.document.head.removeChild(link);
        });

        // Create new favicon link for SVG
        const linkSvg = this.document.createElement('link');
        linkSvg.rel = 'icon';
        linkSvg.type = 'image/svg+xml';
        linkSvg.href = iconPath;
        this.document.head.appendChild(linkSvg);

        // Create new favicon link for PNG (fallback)
        const linkPng = this.document.createElement('link');
        linkPng.rel = 'icon';
        linkPng.type = 'image/png';
        linkPng.href = iconPath;
        this.document.head.appendChild(linkPng);
    }
}
